module.exports = __webpack_public_path__ + "static/media/028-computer-2.00d33181.svg";